import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { Alert, Button, Form, Input, Space, Typography, Row, Col, Grid } from 'antd';
// import { EyeFilled, EyeInvisibleOutlined } from '@ant-design/icons';
import { useResetLifePassWordValidate } from 'all-in-one-shared-api';
import { StyledCheckbox } from './components/index';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { setErrorCodeFun } from 'utils';
import eyeOpen from 'assets/images/Mask.svg';
import eyeClose from 'assets/images/redMask.svg';
import {
  // useContext,
  useState,
} from 'react';
import { ForgotPasswordData } from '../life/forget/forgotPasswordData';
import PolicyAndMemberIdModal from '../life/forget/PolicyAndMemberIdModal';
import { revalidateAntdFormLanguageChanged } from '../../i18n';
import {
  // RegistrationFlowContext,
  RegistrationFormData,
} from 'contexts/registration';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import styled from 'styled-components';
import GreetingSection from '../../components/navbar/GreetingSection';
const { useBreakpoint } = Grid;
import './changepwd.less';

const ResponsiveContainer = styled.div`
  padding-left: 40px;
  padding-right: 40px;
  @media (max-width: 992px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

interface LocationState {
  loginId?: string;
  mobile?: string;
  email?: string;
  countryCode?: string;
  areaCode?: string;
}

function ForgotPasswordResetPage() {
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  // const { state } = useContext(RegistrationFlowContext);
  const { t, i18n } = useTranslation();
  const [formDataState, setFormDataState] = React.useState<ForgotPasswordData>({
    email: '',
  });
  const [state, setState] = useState({
    password: '',
    confirmPassword: '',
  });
  const location = useLocation();
  const navigate = useNavigate();
  const [errmessage, setErrmessage] = useState<string | null>(null);
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [form] = Form.useForm();
  const [isValidate, setIsValidate] = React.useState(false);
  const [errors, setErrors] = useState<string | null>(null);
  const [errorsmsg, setErrorsmsg] = useState<string>('');
  const { lg } = useBreakpoint();
  const { token } = useKeycloakReady();
  const { loginId, mobile, email, countryCode, areaCode } = (location.state as LocationState) ?? {};
  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [i18n.language, form]);
  const [randoms, setRandoms] = useState(Math.random());

  const { data, shouldFetch, error } = useResetLifePassWordValidate(
    'useResetLifePassWordValidate' + randoms,
    // 'useResetLifePassWordValidate',
    formDataState.confirmPassword ?? '',
    token ?? '',
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
    },
  );
  // console.log('state', state);
  const [password, setPassword] = useState('');
  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
    if (
      e.target.value?.length >= 8 &&
      /[a-zA-Z]/.test(e.target.value) &&
      /\d/.test(e.target.value) &&
      /[A-Z]/.test(e.target.value) &&
      /[a-z]/.test(e.target.value) &&
      /\d/.test(e.target.value)
    ) {
      setIsValidate(true);
    } else {
      setIsValidate(false);
    }
    setState({
      ...state,
      password: e.target.value,
    });
  };

  const handleConfirmPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState({
      ...state,
      confirmPassword: e.target.value,
    });
  };
  const closeModel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if (error && error?.code) {
      setErrors(error.code);
      setErrorsmsg(error.message);
      const message = setErrorCodeFun(error.code, i18n.language);
      setErrmessage(message ?? error.message);
    }
    if (i18n.language && errors) {
      const message = setErrorCodeFun(errors, i18n.language);
      setErrmessage(message ?? errorsmsg);
    }
  }, [error, shouldFetch, i18n.language, errors, errorsmsg]);

  const onFinish = (values: RegistrationFormData) => {
    setFormDataState({
      password: values.password,
      confirmPassword: values.confirmPassword,
    });
  };
  useEffect(() => {
    if (formDataState.confirmPassword) {
      setRandoms(Math.random());
      shouldFetch(true);
    }
  }, [formDataState, shouldFetch]);
  useEffect(() => {
    if (data && !error) {
      navigate('/afterOtpVerification', {
        replace: true,
        state: {
          loginId,
          mobile,
          email,
          countryCode,
          password: formDataState.confirmPassword,
          areaCode,
        },
      });
      shouldFetch(false);
    }
    // eslint-disable-next-line
  }, [data, error, shouldFetch]);

  return (
    <ResponsiveContainer>
      {lg && (
        <Typography.Title
          level={3}
          style={{
            fontSize: '33px',
            fontFamily: 'Roboto400',
            color: '#20252B',
            fontWeight: '400',
            marginTop: '40px',
            marginBottom: '40px',
          }}
        >
          {t('life.changePassword.title')}
        </Typography.Title>
      )}
      {!lg && <GreetingSection pageName={t('life.changePassword.title')} showicon={false} />}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'white',
          width: '100%',
        }}
      >
        <Row
          className="changpwd-content"
          justify="center"
          style={{ maxWidth: '672px' }}
          gutter={[16, { xs: 8, sm: 16, md: 22 }]}
        >
          <Col xs={24} md={24} style={{ display: 'flex', marginTop: '40px' }}>
            <Typography.Text style={{ fontSize: '17px' }}>{t('life.changePassword.subtitle')}</Typography.Text>
          </Col>
          <Col xs={24} md={24} style={{ display: 'flex' }}>
            <Space style={{ marginTop: 16, marginBottom: 16 }}>
              <Typography.Text style={{ color: '#752127', fontSize: '17px' }}>
                {t('forgetPassword.mandatoryMsg')}
              </Typography.Text>
            </Space>
          </Col>
          <Form
            layout={'vertical'}
            requiredMark={false}
            onFinish={onFinish}
            form={form}
            validateTrigger={'onBlur'}
            style={{ width: '100%', marginTop: '18px' }}
          >
            <Col xs={24} md={24}>
              <BoldLabelFormItem
                label={
                  <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px' }}>
                    {t('resetPassword.passwordLabel')}
                  </span>
                }
                name="password"
              >
                <Input
                  size="middle"
                  maxLength={12}
                  disabled={false}
                  placeholder={t('resetPassword.passwordPlaceholder')}
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #E5E5E5',
                    // color: "white",
                    backgroundColor: 'transparent',
                  }}
                  onChange={handlePasswordChange}
                  type={visible ? 'text' : 'password'}
                  // placeholder={placeholder}
                  suffix={
                    <span
                      onClick={() => setVisible(!visible)}
                      style={{
                        cursor: 'pointer',
                        backgroundColor: 'transparent',
                      }}
                    >
                      {visible ? <img src={eyeOpen} /> : <img src={eyeClose} />}
                    </span>
                  }
                />
                <div style={{ marginTop: 16 }}>
                  <div className="checkbox-pwd">
                    <StyledCheckbox checked={password?.length >= 8 && /[a-zA-Z]/.test(password) && /\d/.test(password)}>
                      <Typography.Text>{t('forgetPassword.Minimumcharacters')}</Typography.Text>
                    </StyledCheckbox>
                  </div>
                  <div className="checkbox-pwd">
                    <StyledCheckbox checked={/[A-Z]/.test(password) && /[a-z]/.test(password)}>
                      <Typography.Text>{t('forgetPassword.ContainsUppercase')}</Typography.Text>
                    </StyledCheckbox>
                  </div>
                  <div className="checkbox-pwd">
                    <StyledCheckbox checked={/\d/.test(password)}>
                      <Typography.Text>{t('forgetPassword.ContainsDigit')}</Typography.Text>
                    </StyledCheckbox>
                  </div>
                </div>
              </BoldLabelFormItem>
            </Col>
            <Col xs={24} md={24}>
              <BoldLabelFormItem
                label={
                  <span style={{ color: '#752127', fontWeight: 'normal', fontSize: '17px' }}>
                    {t('life.changePassword.confirmPasswordLabel') + '*'}
                  </span>
                }
                name="confirmPassword"
                dependencies={['password']}
                rules={[
                  { required: true, message: t('registration.error.required') },
                  () => ({
                    validator(_, value) {
                      console.log('value', value, 'getFieldValue', password);
                      if (!value || password === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error(t('registration.error.invalidConfirmPassword')));
                    },
                  }),
                ]}
              >
                <div style={{ position: 'relative' }}>
                  <Input
                    size="middle"
                    maxLength={12}
                    placeholder={t('resetPassword.confirmPasswordPlaceholder')}
                    style={{
                      border: 'none',
                      borderBottom: '1px solid #E5E5E5',
                      // color: "white",
                      backgroundColor: 'transparent',
                    }}
                    type={visible2 ? 'text' : 'password'}
                    onChange={handleConfirmPasswordChange}
                    // placeholder={placeholder}
                    suffix={
                      <span
                        onClick={() => setVisible2(!visible2)}
                        style={{
                          cursor: 'pointer',
                          backgroundColor: 'transparent',
                        }}
                      >
                        {visible2 ? <img src={eyeOpen} /> : <img src={eyeClose} />}
                      </span>
                    }
                  />
                </div>
              </BoldLabelFormItem>
            </Col>

            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <BoldLabelFormItem style={{ width: '80%' }}>
                  {errmessage && (
                    <Alert
                      message={errmessage}
                      type="error"
                      style={{
                        marginBottom: 16,
                        border: 'none',
                      }}
                    />
                  )}
                  <Button
                    block
                    type="primary"
                    disabled={!state.password || !state.confirmPassword || !isValidate}
                    size="large"
                    htmlType="submit"
                    className="change-submit"
                  >
                    {t('common.submit')}
                  </Button>
                </BoldLabelFormItem>
              </div>
            </Col>
          </Form>
        </Row>
      </div>
      <PolicyAndMemberIdModal isModalVisible={isModalVisible} handleModalClose={closeModel} />
    </ResponsiveContainer>
  );
}

export default ForgotPasswordResetPage;
